"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatUrl = exports.formatURLDomain = exports.formatParsedUrl = void 0;
var _urlParsing = require("./url-parsing");
/* eslint-disable prefer-destructuring */

var NS = '';

/**
 * Modify a given URL to make it appropriate for a particular target locale.
 *
 * This logic parses the URL into its constituent pieces, modifies the language, and glues the
 * pieces back together in a particular order. The order is: seo, then lang, then the rest of the
 * pathname, then the search/query string, then the hash.
 *
 * Note that in input URL's we tolerate the lang in a slightly different part of the path, in some
 * cases. So, the pieces we spit out from the formatter may be in a slightly different order.
 *
 * @param {String} url
 * @param {String} locale
 *     Optional locale code e.g. "fr-CA". If not provided, the resulting URL will not include a
 *     language code.
 * @returns {String}
 *     URL appropriate for the target locale
 */
var formatUrl = function formatUrl(url, locale) {
  // Start by parsing the StubHub URL.
  var urlObject = (0, _urlParsing.parseUrl)(url);
  return formatParsedUrl(urlObject, locale);
};

/**
 * Modify an already parsed URL to make it appropriate for a particular target locale.
 *
 * The parsed URL object already has its constituent pieces. We modify the language and glue the
 * pieces back together in a particular order. The order is: seo, then lang, then the rest of the
 * pathname, then the search/query string, then the hash.
 *
 * Note that in input URL's we tolerate the lang in a slightly different part of the path, in some
 * cases. So, the pieces we spit out from the formatter may be in a slightly different order.
 *
 * @param {Object} urlObject
 * @param {String} locale
 *     Optional locale code e.g. "fr-CA". If not provided, the resulting URL will not include a
 *     language code.
 * @returns {String}
 *     URL appropriate for the target locale
 */
exports.formatUrl = formatUrl;
var formatParsedUrl = function formatParsedUrl(urlObject, locale) {
  var sh_lang;
  // Modify language part according to desired target locale.
  if (locale) {
    sh_lang = locale.split(/[-_]/)[0];
  } else {
    sh_lang = NS;
  }

  // Glue the pieces back together to form the resulting URL.
  var result = urlObject.protocol + (urlObject.host ? "//".concat(urlObject.host) : NS) + (urlObject.sh_seo ? "/".concat(urlObject.sh_seo) : NS) + (sh_lang ? "/".concat(sh_lang) : NS) + urlObject.sh_pathname +
  // Always starts with '/'
  urlObject.search + urlObject.hash;
  return result;
};

/**
 * Format a URL using domain information to ensure correct domain routing.
 *
 * @param {String} href
 * @param {String} locale
 *     Locale from react-intl. (Use case: if currentLocale === 'pt-PT' then we give 'pt' to
 *     react-intl for the purpose of its formatting, per Kevin.)
 * @param {String} defaultLocale
 *     Presumably the site's default locale?
 * @param {String} currentLocale
 *     Locale as determined by our locale_check middleware and stored in gsConfig?
 */
exports.formatParsedUrl = formatParsedUrl;
var formatURLDomain = function formatURLDomain(_ref) {
  var href = _ref.href,
    locale = _ref.locale,
    defaultLocale = _ref.defaultLocale,
    currentLocale = _ref.currentLocale;
  // Use locale (if set and non-default), or currentLocale (if set and non-default), or default.
  if (locale) {
    if (locale !== defaultLocale) {
      href = formatUrl(href, locale);
    } else {
      href = formatUrl(href);
    }
  } else if (currentLocale !== defaultLocale) {
    href = formatUrl(href, currentLocale);
  } else {
    href = formatUrl(href);
  }
  return href;
};
exports.formatURLDomain = formatURLDomain;